(function(scope){
  'use strict';
  function create(config,request){
    let chosen=null;
    const choice=cart=>chosen===null?cart.attributes?.tickey_shipping_protection!=='declined':chosen;
    const isProtection=item=>String(item.variant_id)===String(config.variantId);
    async function sync(cart,explicit){
      if(typeof explicit==='boolean')chosen=explicit;
      const selected=choice(cart);
      if(config.reviewOnly)return {cart,selected,changed:false,reviewOnly:true};
      if(!Number.isSafeInteger(config.variantId)||config.variantId<=0)throw Error('Shipping protection is unavailable.');
      let changed=false;
      if(typeof explicit==='boolean'){
        cart=await request('cart/update.js',{attributes:{tickey_shipping_protection:selected?'selected':'declined'}});changed=true;
      }
      const eligible=cart.items.some(item=>!isProtection(item)&&item.requires_shipping&&item.quantity>0);
      const lines=cart.items.filter(isProtection),wanted=eligible&&selected?1:0;
      if(!lines.length&&wanted){
        await request('cart/add.js',{items:[{id:config.variantId,quantity:1}]});
        cart=await request('cart.js');changed=true;
      }else if(lines.length){
        const updates={};lines.forEach((line,i)=>{const qty=i===0?wanted:0;if(line.quantity!==qty)updates[line.key]=qty;});
        if(Object.keys(updates).length){cart=await request('cart/update.js',{updates});changed=true;}
      }
      return {cart,selected,changed,reviewOnly:false};
    }
    return {sync,choice,isProtection};
  }
  const api={create};scope.TickeyProtection=api;if(typeof module!=='undefined'&&module.exports)module.exports=api;
})(typeof window==='undefined'?globalThis:window);
